module.exports = __webpack_public_path__ + "static/media/flowers_Thumb_1.55ea9080.jpg";